<template>
  <section
    id="pricing-section"
    class="pricing-table-roi py-5 bg-light-gray"
  >
    <div class="container text-center">
      <div class="row justify-content-center mb-4">
        <div class="col-lg-8">
          <span
            class="badge badge-success-light text-success-dark
              font-weight-bold px-3 py-2 text-uppercase mb-2"
          >
            Inversión Clara & Retorno Garantizado
          </span>
          <h2 class="h1 font-weight-bold text-dark-blue mb-3">
            Cuesta menos que la consulta de un solo paciente al mes
          </h2>
          <p class="lead text-muted">
            Elegí el plan que mejor se adapte a tu ritmo de trabajo.
            Todo incluido desde el primer día.
          </p>

          <!-- Annual vs Monthly Billing Toggle -->
          <div
            class="d-inline-flex align-items-center bg-white p-2
              rounded-pill shadow-xs border mb-4"
          >
            <button
              class="btn btn-sm rounded-pill font-weight-bold
                px-4 py-2 transition-all"
              :class="isAnnual
                ? 'btn-primary-base shadow-sm'
                : 'btn-light text-muted'"
              @click="isAnnual = true"
            >
              Pago Anual
              <span class="badge badge-success-base ml-1">
                Ahorrás 2 meses
              </span>
            </button>
            <button
              class="btn btn-sm rounded-pill font-weight-bold
                px-4 py-2 transition-all"
              :class="!isAnnual
                ? 'btn-primary-base shadow-sm'
                : 'btn-light text-muted'"
              @click="isAnnual = false"
            >
              Pago Mensual
            </button>
          </div>
        </div>
      </div>

      <!-- Pricing Cards Row -->
      <div class="row justify-content-center align-items-stretch">
        <!-- Gratis / Básico Plan Card -->
        <div class="col-lg-6 col-xl-5 mb-4">
          <div
            class="card h-100 bg-white rounded-xl shadow-sm border p-4
              p-md-5 text-left position-relative"
          >
            <div
              class="position-absolute"
              style="top: 15px; right: 20px;"
            >
              <span
                class="badge badge-light-primary text-primary-dark
                  font-weight-bold p-2"
              >
                Plan Básico
              </span>
            </div>

            <h3 class="h3 font-weight-bold text-dark-blue mb-2">
              Básico
            </h3>
            <p class="text-muted small mb-4">
              Para probar el directorio y comenzar a recibir citas online.
            </p>

            <div class="d-flex align-items-baseline mb-4">
              <span class="display-3 font-weight-bold text-dark-blue">
                $0
              </span>
              <span class="text-muted font-weight-bold ml-2">
                ¡Gratis para siempre!
              </span>
            </div>

            <ul class="list-unstyled mb-4">
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>Oferta de servicios en el Directorio Médico</span>
              </li>
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>Perfil profesional con enlace único personalizable</span>
              </li>
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>
                  Gestión de citas solicitadas por pacientes desde la web
                </span>
              </li>
            </ul>

            <button
              class="btn btn-outline-primary-base btn-block font-weight-bold
                btn-lg mt-auto py-3"
              @click="$emit('start-register')"
            >
              Registrarme Gratis →
            </button>
          </div>
        </div>

        <!-- Main Membership Card -->
        <div class="col-lg-6 col-xl-5 mb-4">
          <div
            class="card h-100 bg-white rounded-xl shadow-md
              border-primary-light p-4 p-md-5 text-left
              position-relative"
          >
            <div
              class="position-absolute"
              style="top: 15px; right: 20px;"
            >
              <span class="badge badge-success-base font-weight-bold p-2">
                Membresía Profesional
              </span>
            </div>

            <h3 class="h3 font-weight-bold text-dark-blue mb-2">
              Membresía AMII Completa
            </h3>
            <p class="text-muted small mb-4">
              Para profesionales que buscan tranquilidad y control total
              de su agenda.
            </p>

            <div class="d-flex align-items-baseline mb-4">
              <span class="display-3 font-weight-bold text-dark-blue">
                ${{ isAnnual ? '200' : '20' }}
              </span>
              <span class="text-muted font-weight-bold ml-2">
                USD / {{ isAnnual ? 'año ($16.6/mes)' : 'mes' }}
              </span>
            </div>

            <ul class="list-unstyled mb-4">
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>Módulo Profesional + AmiiBot en tu Perfil Público</span>
              </li>
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>Módulo para tus Asistentes y Recepcionistas</span>
              </li>
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>App AMII Paciente para récipes y citas</span>
              </li>
              <li class="d-flex align-items-center mb-3">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>
                  Configuración inicial asistida e historia clínica ilimitada
                </span>
              </li>
              <li class="d-flex align-items-center">
                <font-awesome-icon
                  icon="check"
                  class="text-success-base mr-2"
                />
                <span>Soporte técnico dedicado Lunes a Viernes</span>
              </li>
            </ul>

            <button
              class="btn btn-success-base btn-block font-weight-bold
                btn-lg btn-pulse-success mt-auto py-3"
              @click="$emit('start-register')"
            >
              Comenzar Mi Prueba Gratis →
            </button>
          </div>
        </div>
      </div>

      <!-- Additional Pre-paid Services Section -->
      <div class="mt-5 pt-3 border-top">
        <h3 class="h4 font-weight-bold text-dark-blue mb-2 text-center">
          Servicios Adicionales Opcionales (Pre-pagados)
        </h3>
        <p class="text-muted small text-center mb-4">
          Servicios por consumo o paquete no incluidos en la membresía base,
          disponibles cuando los necesites.
        </p>

        <div class="row justify-content-center align-items-stretch">
          <!-- Créditos de IA -->
          <div class="col-md-6 col-lg-5 mb-3">
            <div
              class="card h-100 p-4 bg-white rounded-xl shadow-xs border
                text-left"
            >
              <div
                class="d-flex align-items-center
                  justify-content-between mb-2"
              >
                <h4 class="h5 font-weight-bold text-dark-blue mb-0">
                  ⚡ Créditos de IA
                </h4>
                <span class="badge badge-light-primary font-weight-bold">
                  Desde $15 USD
                </span>
              </div>
              <p class="text-muted small mb-3">
                Paquetes de créditos para potencia asistida por IA:
              </p>
              <ul class="list-unstyled small mb-0">
                <li class="mb-2">
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  <strong>AMII Voz:</strong> Dictado y transcripción
                  en consulta.
                </li>
                <li class="mb-2">
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  <strong>Chat con IA:</strong> Consultas sobre CIE y
                  casos clínicos.
                </li>
                <li>
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  <strong>AmiiBot WhatsApp:</strong> Respuestas automáticas
                  en tu WhatsApp.
                </li>
              </ul>
            </div>
          </div>

          <!-- Rostro de Bebés con IA -->
          <div class="col-md-6 col-lg-5 mb-3">
            <div
              class="card h-100 p-4 bg-white rounded-xl shadow-xs border
                text-left"
            >
              <div
                class="d-flex align-items-center
                  justify-content-between mb-2"
              >
                <h4 class="h5 font-weight-bold text-dark-blue mb-0">
                  👶 Rostro de Bebés con IA
                </h4>
                <span class="badge badge-light-primary font-weight-bold">
                  Desde $15 USD
                </span>
              </div>
              <p class="text-muted small mb-3">
                Proyecciones hiperrealistas a partir de ecografías obstétricas:
              </p>
              <ul class="list-unstyled small mb-0">
                <li class="mb-2">
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  Sube la foto del eco 3D/4D con la cara visible.
                </li>
                <li class="mb-2">
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  AMII entrega proyecciones hiperrealistas del rostro.
                </li>
                <li>
                  <font-awesome-icon
                    icon="check"
                    class="text-primary-base mr-2"
                  />
                  Incluye 2 imágenes por cada eco procesado.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PricingTableROI',
  data() {
    return {
      isAnnual: true,
    };
  },
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.badge-success-light {
  background-color: #d1f2e2;
}
.text-success-dark {
  color: #02592d;
}
.border-primary-light {
  border: 2px solid #007BFF;
}
.bg-success-light {
  background-color: #e6f9f0;
}
</style>
